import React, { Component } from 'react';
import Topnavbar from '../components/topnavbar/Topnavbar';
import Pagetop from '../components/Pagetop/Pagetop';
import Contact from '../components/Contact/Contact';
import Footer from '../components/Footer/Footer';

class Contactpage extends Component {
    componentDidMount(){
        window.scroll(0,0)
    }
    render() {
        return (
            <div>
                <Topnavbar title="Contact Us" />
                <Pagetop title="Contact Us"/>
                <Contact/>
                <Footer/>
            </div>
        );
    }
}

export default Contactpage;